import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type Error as SchemaError } from '../schemas/Error';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @tags SimilarCards
 * @summary Удалить настройки похожих карточек для карточки товара
 */
export const DeleteSimilarCardsContentType = '' as const;
export type DeleteSimilarCardsRequest = void;
export type DeleteSimilarCardsResponses = LinkCommonErrorResponses & {
    /**
     * @description Настройки не найдены
     */
    '404': {
        'application/json': SchemaError;
    };
};
export type DeleteSimilarCardsResponseSuccess = undefined;
export type DeleteSimilarCardsSearchParams = undefined;
export type DeleteSimilarCardsPathParameters = {
    card_id: string;
};
export const DeleteSimilarCardsUrl = '/cards/{card_id}/similar-cards' as const;
export const DeleteSimilarCardsMethod = 'DELETE' as const;
export const getDeleteSimilarCardsUrl = (params: DeleteSimilarCardsPathParameters) =>
    DeleteSimilarCardsUrl.replace(/\{(\w+)\}/g, (_match, param: keyof DeleteSimilarCardsPathParameters) =>
        String(params[param])
    );
